var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 54,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8735 41.7454C12.8735 41.7454 10.8155 42.9432 14.3383 43.3485C18.6061 43.8357 20.7872 43.766 25.4904 42.875C25.4904 42.875 26.727 43.651 28.4537 44.3232C17.9106 48.8456 4.59236 44.0611 12.8735 41.7454M11.5852 35.8438C11.5852 35.8438 9.27686 37.554 12.8023 37.9188C17.3612 38.3896 20.9615 38.4281 27.1915 37.2275C27.1915 37.2275 28.0532 38.1018 29.4081 38.58C16.6608 42.3106 2.46257 38.8741 11.5852 35.8438",
    fill: "#932A9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4463 25.8307C25.0442 28.8241 21.7637 31.5179 21.7637 31.5179C21.7637 31.5179 28.36 28.1098 25.3306 23.8419C22.5013 19.8622 20.3315 17.8845 32.0777 11.0664C32.0777 11.0664 13.64 15.6751 22.4463 25.8306",
    fill: "#9D34E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3905 46.1091C36.3905 46.1091 37.9135 47.365 34.7131 48.3367C28.6275 50.1819 9.38397 50.7391 4.03814 48.4102C2.11653 47.5737 5.72023 46.4125 6.85373 46.1688C8.03589 45.9122 8.71156 45.9601 8.71156 45.9601C6.57445 44.4532 -5.10178 48.9187 2.78066 50.1974C24.277 53.6865 41.9663 48.6264 36.3905 46.1091ZM13.8633 29.7278C13.8633 29.7278 4.07494 32.0548 10.3971 32.8996C13.0664 33.2573 18.3878 33.1765 23.3445 32.7607C27.3954 32.4189 31.4631 31.6916 31.4631 31.6916C31.4631 31.6916 30.0347 32.3039 29.0013 33.0101C19.0612 35.6266 -0.141124 34.4094 5.38699 31.733C10.0621 29.4712 13.8634 29.7278 13.8634 29.7278M31.4227 39.5511C41.5274 34.2959 36.8554 29.2458 33.5944 29.9263C32.7951 30.0927 32.4388 30.2369 32.4388 30.2369C32.4388 30.2369 32.7355 29.7718 33.3022 29.5705C39.7533 27.3004 44.7147 36.2654 31.2196 39.816C31.2196 39.8161 31.376 39.6763 31.4227 39.5511",
    fill: "#932A9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3305 0.0587498C25.3305 0.0587498 30.9266 5.66164 20.0229 14.2768C11.2794 21.1879 18.0291 25.1283 20.0193 29.6305C14.9155 25.0217 11.1699 20.9646 13.6828 17.1886C17.3709 11.6455 27.5883 8.95814 25.3305 0.0585938",
    fill: "#9D34E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8554 53.7935C24.5546 54.415 39.4486 53.4487 39.8013 48.8555C39.8013 48.8555 39.1233 50.5969 31.7855 51.9797C23.5071 53.5388 13.297 53.3568 7.24121 52.3575C7.24137 52.3575 8.48091 53.3844 14.8556 53.7935",
    fill: "#932A9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9261,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.b86ec6374642b2cb7cf2a4c19ab5285b.svg";
export { ForwardRef as ReactComponent };